import React from 'react';
import useScrollProgress from 'ui/src/hooks/useScrollProgress';
import { NAVBAR_SCROLL_TO_READING } from 'utils/shared';

interface Props {
  postRef: React.RefObject<HTMLDivElement>;
}

export default function ProgressBar({ postRef }: Props) {
  const { percentage } = useScrollProgress(postRef, NAVBAR_SCROLL_TO_READING, 100);

  return (
    <div className="bg-site-neutrals-100 fixed top-20 z-30 h-2.5 w-full">
      <div style={{ width: `${percentage}%` }} className="bg-site-primary-600 h-full max-w-full" />
    </div>
  );
}
